/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ForgotPasswordMailRequestFromJSON(json) {
    return ForgotPasswordMailRequestFromJSONTyped(json, false);
}
export function ForgotPasswordMailRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        organizationSubdomain: !exists(json, 'organization_subdomain') ? undefined : json['organization_subdomain'],
        encryptedEmail: !exists(json, 'encrypted_email') ? undefined : json['encrypted_email']
    };
}
export function ForgotPasswordMailRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        organization_subdomain: value.organizationSubdomain,
        encrypted_email: value.encryptedEmail
    };
}
